import React, { useState } from "react";
import { Button, TableContainer, Table, TableHead, TableRow, TableCell, TableBody, Avatar, Tooltip, tooltipClasses, styled } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { Reschedule } from "./Reschedule";
import { dateFormatterV3 } from "../../../utils/formatter";
import ModalConfirm from "../../../components/base/ModalConfirm";
import { Close } from "@mui/icons-material";
import { useDispatch } from "react-redux";
import { postApi } from "../../../store/apis";
import { useSnackbar } from "notistack";
const TablelistSchedule = ({ theme, dataSet, ava, refetch }) => {
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();
  const [dialog, setDialog] = useState({
    post: false,
    view: false,
  });
  const [pocket, setPocket] = useState(null);
  const [formateDate, setDate] = useState(null);
  const [element, setElement] = useState(<></>);
  const navigate = useNavigate();
  const Poper = styled(({ className, ...props }) => <Tooltip placement="bottom-start" {...props} classes={{ popper: className }} />)(({ theme }) => ({
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: "#fff",
      maxWidth: 200,
      border: "2px solid #007585",
      borderRadius: "8px",
    },
  }));

  const onReschedule = (item) => {
    setPocket(item);
    setDialog({ ...dialog, post: true });
  };

  const onRefetch = (item) => {
    let datas = [...dataSet];
    let itemIndex = dataSet.findIndex((x) => x.id === item.id && x.feature === item.feature);
    datas[itemIndex] = { ...item };
    refetch && refetch(datas);
  };

  const onCancel = (data) => {
    setElement(
      <ModalConfirm
        visible={true}
        icon={<Close style={{ color: theme.white, width: "3.5rem", height: "3.5rem" }} />}
        variant="danger"
        titleBtnNo="Tutup"
        titleBtnYes="Batalkan Jadwal"
        onNo={() => emptyElement()}
        onYes={() => onCancelSchedule(data)}>
        <h4>Batalkan Jadwal Konsultasi ?</h4>
        <p>Klien akan di arahkan untuk memilih ulang jadwal dan psikolog</p>
      </ModalConfirm>
    );
  };

  const emptyElement = () => {
    setElement(undefined);
  };

  const onCancelSchedule = async (item) => {
    let config = {};
    switch (item.feature) {
      case "coaching":
        config = {
          path: `konselor/coach/cancel-schedule`,
          body: {
            id: item.id,
          },
        };
        break;
      case "konsultasi":
        config = {
          path: `konselor/index-konselor/cancel`,
          body: {
            id: item.id,
            cancel_konsultasi: "1",
          },
        };
        break;
      default:
        config = {};
        break;
    }

    await dispatch(postApi(config))
      .then((data) => {
        let datas = { ...item };
        datas.status = "Selesai";
        onRefetch(datas);
        emptyElement();
        enqueueSnackbar("Jadwal Berhasil Dibatalkan", { variant: "success" });
      })
      .catch((err) => {
        const variant = "error";
        if (err.data.errors) {
          const error = err.data.errors;
          Object.keys(error).forEach((message) => {
            enqueueSnackbar(error[message], { variant });
          });
        } else {
          enqueueSnackbar(err.message ?? "Kelas Gagal Dibatalkan", { variant });
        }
      });
  };

  const setColorStatus = (value) => {
    let color = "#0B81C2";
    switch (value) {
      case "Aktif":
        color = "#00786A";
        break;
      case "Selesai":
        color = "#6D0BCF";
        break;
      case "Kadaluwarsa":
        color = "#B80222";
        break;
      default:
        color = "#0B81C2";
        break;
    }

    return color;
  };

  return (
    <div>
      <TableContainer component="div">
        <Table aria-label="simple table" style={{ borderBottom: "none" }}>
          <TableHead>
            <TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
              <TableCell style={{ background: theme.tertiary, borderRadius: "10px 0 0 10px" }} className="py-1">
                <p className="font-weight-bold" style={{ color: theme.primary }}>
                  No
                </p>
              </TableCell>
              <TableCell style={{ background: theme.tertiary }} className="py-1">
                <p className="font-weight-bold" style={{ color: theme.primary }}>
                  Nama Klien
                </p>
              </TableCell>
              <TableCell style={{ minWidth: "190px", background: theme.tertiary }} className="py-1" align="center">
                <p className="font-weight-bold white-space-pre" style={{ color: theme.primary }}>
                  Tgl. & Waktu
                </p>
              </TableCell>
              <TableCell style={{ background: theme.tertiary }} className="py-1">
                <p className="font-weight-bold" style={{ color: theme.primary }}>
                  Kategori
                </p>
              </TableCell>
              <TableCell style={{ background: theme.tertiary }} className="py-1">
                <p className="font-weight-bold" style={{ color: theme.primary }}>
                  Layanan
                </p>
              </TableCell>
              <TableCell style={{ background: theme.tertiary }} className="py-1" align="center">
                <p className="font-weight-bold" style={{ color: theme.primary }}>
                  Status
                </p>
              </TableCell>
              <TableCell style={{ background: theme.tertiary, borderRadius: "0 10px 10px 0" }} className="py-1">
                <p className="font-weight-bold" style={{ color: theme.primary }}>
                  Tindakan
                </p>
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {dataSet.map((item, i) => (
              <TableRow key={i} sx={{ "&:last-child td, &:last-child th": { border: 0 } }}>
                <TableCell>{i + 1}</TableCell>
                <TableCell>
                  <div className="d-flex align-center font-weight-500">
                    <Avatar alt={item.nama} src={item.data_pelanggan.foto_link ? item.data_pelanggan.foto_link : ava} className="mr-3" />
                    <p> {item.data_pelanggan?.nama ?? ""} </p>
                  </div>
                </TableCell>
                <TableCell align="center">
                  <div className="d-flex gap-2 align-center justify-center font-weight-500">
                    {dateFormatterV3(item.date)}
                    <div style={{ height: "1rem", width: "2px", background: theme.secondary }} />
                    {item.wkt_konsultasi ? item.wkt_konsultasi.substring(0, 5) : ""} {item.wkt_konsultasi ? "WIB" : ""}
                  </div>
                </TableCell>
                <TableCell>{item.kategori}</TableCell>
                <TableCell>{item.layanan}</TableCell>
                <TableCell align="center">
                  <p className="font-weight-bold" style={{ color: setColorStatus(item.status) }}>
                    {item.status}
                  </p>
                </TableCell>
                <TableCell>
                  <div className="d-flex align-center">
                    <Button
                      variant="contained"
                      className="rounded-xl capitalize mr-3"
                      disableElevation
                      size="small"
                      style={{ background: theme.act_pink }}
                      onClick={() => navigate(`/profile-client/${item.id_pelanggan}`)}>
                      <p className="font-weight-bold" style={{ color: theme.act_lbl_pink }}>
                        Profile
                      </p>
                    </Button>
                    {item.status === "Aktif" ? (
                      <Button variant="contained" className="rounded-xl capitalize mr-3" disableElevation size="small" style={{ background: theme.act_green }}>
                        <p className="font-weight-bold" style={{ color: theme.act_lbl_green }}>
                          Mulai
                        </p>
                      </Button>
                    ) : (
                      <></>
                    )}
                    {item.status === "Akan Datang" && item.hours_remaining >= 3 ? (
                      <Button variant="contained" className="rounded-xl capitalize mr-3" disableElevation size="small" style={{ background: theme.act_orange }} onClick={() => onReschedule(item)}>
                        <p className="font-weight-bold" style={{ color: theme.act_lbl_orange }}>
                          Resch.
                        </p>
                      </Button>
                    ) : (
                      <></>
                    )}
                    {(item.status === "Akan Datang" || item.status === "Aktif") && (item.hours_remaining >= 3 || item.hours_remaining < 0) ? (
                      <Button variant="contained" className="rounded-xl capitalize mr-3" disableElevation size="small" style={{ background: theme.act_red }} onClick={() => onCancel(item)}>
                        <p className="font-weight-bold" style={{ color: theme.act_lbl_red }}>
                          Cancel
                        </p>
                      </Button>
                    ) : (
                      <></>
                    )}
                    <Poper
                      title={
                        <React.Fragment>
                          <div className="pa-2">
                            <p className="font-weight-bold mb-1" style={{ color: theme.primary, fontSize: "15px" }}>
                              Topik Konsultasi
                            </p>
                            <p style={{ color: "#000", fontSize: "13px" }}>{item.keterangan}</p>
                          </div>
                        </React.Fragment>
                      }>
                      <Button variant="contained" className="rounded-xl capitalize mr-3" disableElevation size="small" style={{ background: theme.act_blue }}>
                        <p className="font-weight-bold" style={{ color: theme.act_lbl_blue }}>
                          Topik
                        </p>
                      </Button>
                    </Poper>

                    {item.status === "Selesai" ? (
                      <Button variant="contained" onClick={() => {}} className="rounded-xl capitalize mr-3" disableElevation size="small" style={{ background: theme.act_purple }}>
                        <p className="font-weight-bold" style={{ color: theme.act_lbl_purple }}>
                          Riwayat
                        </p>
                      </Button>
                    ) : (
                      <></>
                    )}
                    <Button
                      variant="contained"
                      className="rounded-xl capitalize mr-3"
                      disableElevation
                      size="small"
                      style={{ background: theme.act_blue }}
                      onClick={() => navigate(`/schedule-detail/${item.id}/${item.feature}`)}>
                      <p className="font-weight-bold" style={{ color: theme.act_lbl_blue }}>
                        Detail
                      </p>
                    </Button>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <div className="pa-2">
        <Reschedule close={() => setDialog({ ...dialog, post: false })} d_rscdl={dialog.post} pocket={pocket} selected={formateDate} setDate={setDate} refetch={(item) => onRefetch(item)} />
        {element}
      </div>
    </div>
  );
};

export default TablelistSchedule;
